<template>
  <div id="app">
    <div class="app-main">
      <Nav v-show="!hideNav" :isNavCollapsed="isNavCollapsed" @collapse="isNavCollapsed = true"></Nav>
      <img class="thumb" src="@/assets/logo.png" alt="logo" @click="showNav" v-show="isNavCollapsed && !hideNav">

      <div class="app-container">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/nav/Nav.vue'

export default {
  components: {
    Nav
  },
  data() {
    return {
      hideNav: true,
      isNavCollapsed: false
    }
  },
  watch: {
    '$route': function () {
      if (this.$route.path == '/login' || this.$route.path == '/auth-loading') {
        this.hideNav = true;
      } else {
        this.hideNav = false;
      }
    }
  },
  methods: {
    showNav() {
      this.isNavCollapsed = false;
      const header = document.querySelector('.page-header');
      if (header) {
        header.style.height = '';
      }
      const main = document.querySelector('.page-main');
      if (main) {
        main.style.paddingLeft = '';
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.app-main {
  height: 100vh;
  display: flex;
  overflow-y: hidden;
  overflow-x: auto;

  .thumb {
    position: fixed;
    top: 0px;
    right: 0px;
    z-index: 999;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
  }
}
</style>
